import {useLocation} from "react-router-dom";

export const useLinkClassName = (href: string) => {
	const {pathname} = useLocation();
	const isActive = pathname === href;
	return isActive ? "active" : "";
};
